import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Table, Icon, Popup, Card, Label, Image } from 'semantic-ui-react';
import { scientificFormat } from '../../utils/helpers/formatting';

const TELEGRAM_HANDLE_LENGTH = 20;

const tableStyle = {
  fontSize: 12,
};

const Username = ({
  handle,
}) => {
  const maxLength = TELEGRAM_HANDLE_LENGTH;
  const isBigUsername = _.size(handle) > maxLength;
  if (isBigUsername) {
    return (
      <Popup
        content={handle} trigger={
          <span>{_.truncate(handle, { length: maxLength }) || '-'}</span>
        }
      />
    );
  }
  return <span>{handle}</span>;
};

Username.propTypes = {
  handle: PropTypes.string.isRequired,
};

const TelegramExternalLink = ({
  handle,
}) => (
  <a
    href={`https://t.me/${handle}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Username handle={handle} />
  </a>);

const telegramChannelsType = {
  CHANNEL: 'C',
  USER: 'U',
  GROUP: 'G',
  SUPERGROUP: 'SG',
};

TelegramExternalLink.propTypes = {
  handle: PropTypes.string.isRequired,
};

const TelegramChannelInfo = props => {
  console.log(props);
  const { channelType, followerCount, username, thumbnail } = props;
  return (
    <Table.Row>
      <Table.Cell width={1} textAlign="left">
        <Image src={thumbnail} avatar size="mini" />
      </Table.Cell>
      <Table.Cell width={9} textAlign="left">
        <TelegramExternalLink handle={username} platform="telegram" />
      </Table.Cell>
      <Table.Cell width={1}>
        <Popup
          content={_.capitalize(channelType)}
          trigger={
            <Label basic circular color="blue" key="blue">
              {telegramChannelsType[channelType] || '-'}
            </Label>
          }
        />
      </Table.Cell>
      <Table.Cell width={1}>
        {scientificFormat(followerCount) || '-'}
      </Table.Cell>
    </Table.Row>
  );
};

const TelegramChannelsTable = influencer => (
  <Card>
    <Card.Content>
      <Icon name="telegram" size="medium" color="blue" />Telegram
      <Table
        style={tableStyle}
        stackable
        basic="very"
        textAlign="center"
        verticalAlign="middle"
      >
        <Table.Body>
          {_.map(influencer.telegramChannels, telegram =>
            <TelegramChannelInfo {...telegram} />,
          )}
        </Table.Body>
      </Table>
    </Card.Content>
  </Card>
);

TelegramChannelInfo.propTypes = {
  channelType: PropTypes.string.isRequired,
  followerCount: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
};

TelegramChannelInfo.defaultProps = {
  followerCount: null,
};

export default TelegramChannelsTable;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-social-channels-table/telegram-channels.js
 **/